import ProductSegment from './ProductSegment';
import { AlertItem } from './AlertConfiguration';

// Unfortunately we cannot use numeric enums because they are not typesafe
// more info https://github.com/microsoft/TypeScript/issues/32690
export enum OperationType {
  CreateSegment = 'CreateSegment',
  EditSegment = 'EditSegment',
  CloneSegment = 'CloneSegment',
  DeleteSegment = 'DeleteSegment',
  AlertManagement = 'AlertManagement',
  ConfigureAssociatedProducts = 'ConfigureAssociatedProducts',
  CreateAlert = 'CreateAlert',
  EditAlert = 'EditAlert',
  CloneAlert = 'CloneAlert',
  DeleteAlert = 'DeleteAlert',
  RunAlert = 'RunAlert',
}

export type SelectedOperation =
  | { type: OperationType.AlertManagement }
  | { type: OperationType.CreateSegment }
  | { type: OperationType.EditSegment; productSegment: ProductSegment }
  | { type: OperationType.CloneSegment; productSegment: ProductSegment }
  | { type: OperationType.DeleteSegment; productSegment: ProductSegment; operation: () => {} }
  | { type: OperationType.ConfigureAssociatedProducts; productSegment: ProductSegment }
  | { type: OperationType.CreateAlert; segmentId: number }
  | { type: OperationType.EditAlert; alert: AlertItem }
  | { type: OperationType.CloneAlert; alert: AlertItem }
  | { type: OperationType.DeleteAlert; alert: AlertItem; operation: () => Promise<unknown> }
  | { type: OperationType.RunAlert; alert: AlertItem; operation: () => Promise<unknown> };
